import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Observable, of } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { ConfigurationOptionService } from '../../configuration-option.service'
import { ConfigOptionModule } from '../../configuration-option'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { configurationOptionActions } from '../../configuration-option.actions'
import { ISO639LanguageCodes } from 'src/app/shared/utils/languageCodes'
@UntilDestroy()
@Component({
  selector: 'configuration-option-login-page',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionLoginPageCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()
  @Input() formValues: any
  @Input() isCollapsed: any = false
  @Input() isloadingFromParentPage: any = false
  public formValues$: Observable<any>

  //public isCollapsed = false

  public isLoading$: Observable<boolean>
  public shopFooterImageUrl$: Observable<string>
  public shopSubscriptionImageUrl$: Observable<string>
  public shopTicketImageUrl$: Observable<string>
  public shopCourseImageUrl$: Observable<string>
  public shopFacilityImageUrl$: Observable<string>
  public shopProductImageUrl$: Observable<string>
  public shopMultiDayBookingsImageUrl$: Observable<string>
  public shopGroupActivitiesImageUrl$: Observable<string>
  private configOptionModule: ConfigOptionModule =
    environment.moduleConfigs?.configOptionModule
  public isShopEnabled: boolean = true
  public form: UntypedFormGroup
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )
  public formFieldsEditeds = {}
  public shopRentalProductImageUrl$: Observable<string>
  public shopSerieProposalImageUrl$: Observable<string>
  public availableLanguageCodes = environment.availableLanguageCodes ?? [
    ISO639LanguageCodes.English
  ]
  public sectionTitle = ['loginButtonsText', 'loginPageTexts']
  public subSectionTitle = {
    loginButtonsText: {
      name: ['emailLogin', 'surfconextLogin', 'acmIdmLogin'],
      formControlName: [
        'emailLoginButtonText',
        'surfconextButtonText',
        'acmIdmButtonText'
      ]
    },
    loginPageTexts: {
      name: ['oidcAuthentication', 'loginWithEmail', 'register'],
      formControlName: [
        'oidcAuthenticationText',
        'loginWithEmailText',
        'registerText',
        'samlText'
      ]
    }
    // samlShibboleth: {
    //   name: ['saml'],
    //   formControlName: ['samlText']
    // }
  }

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private actions$: Actions,
    private notificationService: NotificationService,
    private configurationOptionService: ConfigurationOptionService,
    public accessRightService: UserAccessRightService
  ) {}
  config: any = {
    placeholder: '',
    tabsize: 2,
    dialogsInBody: true,
    height: '200px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
      'opensans',
      'sansserif',
      'monospace',
      'serif'
    ]
  }

  ngOnInit() {
    this.form = this.fb.group({
      nl_landing_page_branding: [null, []],
      en_landing_page_branding: [null, []],
      fr_landing_page_branding: [null, []],
      de_landing_page_branding: [null, []],
      emailLoginButtonTextNl: [],
      emailLoginButtonTextEn: [],
      surfconextButtonTextNl: [],
      surfconextButtonTextEn: [],
      acmIdmButtonTextNl: [],
      acmIdmButtonTextEn: [],
      emailLoginButtonTextFr: [],
      emailLoginButtonTextDe: [],
      surfconextButtonTextFr: [],
      surfconextButtonTextDe: [],
      acmIdmButtonTextFr: [],
      acmIdmButtonTextDe: [],
      oidcAuthenticationTextNl: [],
      oidcAuthenticationTextEn: [],
      oidcAuthenticationTextFr: [],
      oidcAuthenticationTextDe: [],
      loginWithEmailTextNl: [],
      loginWithEmailTextEn: [],
      loginWithEmailTextFr: [],
      loginWithEmailTextDe: [],
      registerTextNl: [],
      registerTextEn: [],
      registerTextFr: [],
      registerTextDe: [],
      samlTextNl: [],
      samlTextEn: [],
      samlTextFr: [],
      samlTextDe: []
    })

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
    this.formValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) => {
          return this.configurationOptionService.mapEntitiesToObject(
            configOptions
          )
        })
      )

    this.shopFooterImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_footer_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )

    this.shopSubscriptionImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_subscription_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )

    this.shopTicketImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_ticketing_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )
    this.shopCourseImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_course_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )

    this.shopProductImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_product_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )

    this.shopFacilityImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_facility_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )

    this.shopMultiDayBookingsImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_multi_day_bookings_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map(
          (configOption) =>
            `${environment.staticAssetBaseUrl}${configOption.value}`
        )
      )

    this.shopGroupActivitiesImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_group_activities_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          if (configOption.value) {
            return `${environment.staticAssetBaseUrl}${configOption.value}`
          }
        })
      )

    this.shopRentalProductImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_rental_product_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          if (configOption.value) {
            return `${environment.staticAssetBaseUrl}${configOption.value}`
          }
        })
      )

    this.shopSerieProposalImageUrl$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'shop_serie_proposal_image_path'
      )
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          if (configOption.value) {
            return `${environment.staticAssetBaseUrl}${configOption.value}`
          }
        })
      )
    this.formValues$
      ?.pipe(
        filter((formValues) => formValues?.login_buttons_text),
        untilDestroyed(this)
      )
      .subscribe((formValues) => {
        if (formValues?.login_buttons_text) {
          const formValuesParsed = JSON.parse(formValues.login_buttons_text)

          this.form?.patchValue({
            emailLoginButtonTextNl: formValuesParsed.email_login_button_text_nl,
            emailLoginButtonTextEn: formValuesParsed.email_login_button_text_en,
            surfconextButtonTextNl: formValuesParsed.surfconext_button_text_nl,
            surfconextButtonTextEn: formValuesParsed.surfconext_button_text_en,
            acmIdmButtonTextNl: formValuesParsed.acmIdm_button_text_nl,
            acmIdmButtonTextEn: formValuesParsed.acmIdm_button_text_en,
            emailLoginButtonTextFr: formValuesParsed.email_login_button_text_fr,
            emailLoginButtonTextDe: formValuesParsed.email_login_button_text_de,
            surfconextButtonTextFr: formValuesParsed.surfconext_button_text_fr,
            surfconextButtonTextDe: formValuesParsed.surfconext_button_text_de,
            acmIdmButtonTextFr: formValuesParsed.acmIdm_button_text_fr,
            acmIdmButtonTextDe: formValuesParsed.acmIdm_button_text_de
          })
        }

        if (formValues?.login_page_texts) {
          const loginPageTextsFormValuesParsed = JSON.parse(
            formValues.login_page_texts
          )

          this.form?.patchValue({
            oidcAuthenticationTextNl:
              loginPageTextsFormValuesParsed.oidc_authentication_nl,
            oidcAuthenticationTextEn:
              loginPageTextsFormValuesParsed.oidc_authentication_en,
            oidcAuthenticationTextFr:
              loginPageTextsFormValuesParsed.oidc_authentication_fr,
            oidcAuthenticationTextDe:
              loginPageTextsFormValuesParsed.oidc_authentication_de,
            loginWithEmailTextNl:
              loginPageTextsFormValuesParsed.login_with_email_nl,
            loginWithEmailTextEn:
              loginPageTextsFormValuesParsed.login_with_email_en,
            loginWithEmailTextFr:
              loginPageTextsFormValuesParsed.login_with_email_fr,
            loginWithEmailTextDe:
              loginPageTextsFormValuesParsed.login_with_email_de,
            registerTextNl: loginPageTextsFormValuesParsed.register_nl,
            registerTextEn: loginPageTextsFormValuesParsed.register_en,
            registerTextFr: loginPageTextsFormValuesParsed.register_fr,
            registerTextDe: loginPageTextsFormValuesParsed.register_de
          })
        }
        if (formValues) {
          this.form?.patchValue({
            samlTextNl: formValues.samlTextNl,
            samlTextEn: formValues.samlTextEn,
            samlTextFr: formValues.samlTextFr,
            samlTextDe: formValues.samlTextDe
          })
        }
      })
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((data) => {
      this.formValues$.pipe(take(1)).subscribe((formValues) => {
        const keysChanged = this.compareObjects(data, formValues)
        keysChanged.forEach((keys) => {
          this.formFieldsEditeds[keys] = this.form.controls[keys].value
        })
      })
    })
  }

  public onSubmitImage(file: File, configOptionKey: string) {
    this.configurationOptionService.saveOneWithFile(configOptionKey, file)
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }

    const login_page_texts = JSON.stringify({
      oidc_authentication_nl: this.form.controls.oidcAuthenticationTextNl.value,
      oidc_authentication_en: this.form.controls.oidcAuthenticationTextEn.value,
      oidc_authentication_fr: this.form.controls.oidcAuthenticationTextFr.value,
      oidc_authentication_de: this.form.controls.oidcAuthenticationTextDe.value,
      login_with_email_nl: this.form.controls.loginWithEmailTextNl.value,
      login_with_email_en: this.form.controls.loginWithEmailTextEn.value,
      login_with_email_fr: this.form.controls.loginWithEmailTextFr.value,
      login_with_email_de: this.form.controls.loginWithEmailTextDe.value,
      register_en: this.form.controls.registerTextEn.value,
      register_nl: this.form.controls.registerTextNl.value,
      register_fr: this.form.controls.registerTextFr.value,
      register_de: this.form.controls.registerTextDe.value
    })

    const fieldsToRemove = [
      'oidcAuthenticationTextNl',
      'oidcAuthenticationTextEn',
      'oidcAuthenticationTextFr',
      'oidcAuthenticationTextDe',
      'loginWithEmailTextNl',
      'loginWithEmailTextEn',
      'loginWithEmailTextFr',
      'loginWithEmailTextDe',
      'registerTextEn',
      'registerTextNl',
      'registerTextFr',
      'registerTextDe'
    ]

    const filteredFormValue = { ...this.form.value }

    fieldsToRemove.forEach((field) => {
      delete filteredFormValue[field]
    })

    const valueToSend = {
      ...filteredFormValue,
      login_page_texts
    }

    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(4000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )

    this.configurationOptionService.updateOrCreateMany(valueToSend)
  }
  public compareObjects(
    obj1: Record<string, any>,
    obj2: Record<string, any>
  ): string[] {
    const changedKeys: string[] = []

    // Check each key in obj1 and compare its value to obj2
    for (const key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        if (
          obj1[key] !== obj2[key] &&
          (obj1[key] || typeof obj1[key] === 'undefined') &&
          (obj2[key] || typeof obj2[key] === 'undefined')
        ) {
          changedKeys.push(key)
        }
      }
    }

    return changedKeys
  }
}
